import api, { BACKEND_URL } from "./api";

/**
 * Download a protected installer file by id. Uses cookies (withCredentials).
 * Triggers a browser download with the original filename.
 */
export async function downloadInstaller(installerId, suggestedFilename) {
    try {
        const resp = await api.get(`/downloads/${installerId}`, { responseType: "blob" });
        const blob = new Blob([resp.data], { type: resp.headers["content-type"] || "application/octet-stream" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        // Try to read filename from Content-Disposition
        let filename = suggestedFilename || "installer";
        const cd = resp.headers["content-disposition"];
        if (cd) {
            const m = /filename="?([^";]+)"?/.exec(cd);
            if (m && m[1]) filename = m[1];
        }
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        return { ok: true };
    } catch (e) {
        let message = "Download error";
        if (e.response?.data instanceof Blob) {
            try {
                const text = await e.response.data.text();
                const json = JSON.parse(text);
                message = json.detail || message;
            } catch { /* ignore */ }
        } else {
            message = e.response?.data?.detail || e.message || message;
        }
        return { ok: false, error: message };
    }
}

export { BACKEND_URL };
